import { importProvidersFrom } from '@angular/core';
import { OpenFeatureModule } from '@openfeature/angular-sdk';
import { ConfigCatWebProvider } from '@openfeature/config-cat-web-provider';
import { createConsoleLogger, DataGovernance, LogLevel } from 'configcat-js-ssr';

import { environment } from '../environments/environment';

const openFeatureProvider = ConfigCatWebProvider.create(environment.configcat.sdkKey, {
  pollIntervalSeconds: 5,
  logger: createConsoleLogger(environment.production ? LogLevel.Error : LogLevel.Info),
  baseUrl: environment.configcat.baseUrl,
  dataGovernance: DataGovernance.EuOnly,
});

export function provideFeatureFlags() {
  return [
    importProvidersFrom(
      OpenFeatureModule.forRoot({
        provider: openFeatureProvider,
      }),
    ),
  ];
}
